import * as Encoding             from "encoding-japanese";
import * as Papa                 from "papaparse";
import React, { FC, useState }   from "react";
import { useDropzone }           from "react-dropzone";
import { useDispatch }           from "react-redux";
import { Button, Icon, Message } from "semantic-ui-react";
import ImportCustomer            from "../../../../application/usecase/customer/ImportCustomer";

const CsvImportForm: FC = () => {
  const [csvData, setCsvData] = useState({
    hasData: false,
    value: {},
  });
  const [message, setMessage] = useState("");
  const importCustomer: ImportCustomer = new ImportCustomer(useDispatch());

  const {getRootProps, getInputProps, open} = useDropzone({
    accept: "text/csv, application/vnd.ms-excel",
    noClick: true,
    maxSize: 10485760,
    onDrop: acceptedFiles => {
      const file: File = acceptedFiles[0];
      const fileReader: FileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      fileReader.onload = (event) => {
        if (event.target !== null) {
          // @ts-ignore
          const codes: Uint8Array = new Uint8Array(event.target.result);

          // @ts-ignore
          const encoding: Encoding = Encoding.detect(codes);

          // @ts-ignore
          const utf8String: string = Encoding.convert(codes, {
            to: "UNICODE",
            from: encoding,
            type: "string"
          });

          Papa.parse(utf8String, {
            header: true,
            skipEmptyLines: true,
            complete: results => setCsvData({
              hasData: true,
              value: results.data,
            })
          })
        }
      };
    }
  });

  return (
    <>
      {
        message === ""
          ?
          <></>
          :
          <>
            <Message
              error={ true }
            >
              <Message.Header>エラー</Message.Header>
              <p>{ message }</p>
            </Message>
          </>
      }

      <div
        { ...getRootProps() }
        style={ {
          marginBottom: "24px",
          width: "100%",
          outline: "dashed 2px darkgrey",
          height: "200px",
          top: "18.5rem",
        } }
      >
        <input { ...getInputProps() }/>
        <div
          style={ {
            textAlign: "center",
            paddingTop: "4rem"
          } }
        >
          ここにファイルをドロップ<br/>または<br/>
          <Button onClick={ open } size="tiny">
            ファイルを選択
          </Button>
        </div>
      </div>

      <Button
        icon
        labelPosition="left"
        disabled={ !csvData.hasData }
        positive={ csvData.hasData }
        onClick={ () => importCustomer.execute(csvData.value, setMessage) }
      >
        <Icon name="upload"/>
        アップロードする
      </Button>
    </>
  );
};

export default CsvImportForm;
